import React from 'react';
import {
	NumberInput,
} from 'react-admin';

import { UserRole } from '../../entities';
import { Currencies } from '../../entities/Currencies';
import { getKeyFromEnumByValue } from '../_helpers/mappers';
import { EditableGridCellField } from './EditableGridCellField';

export const currencyLocales = 'en-US';
// export const currencyOptions = { style: 'currency', currency: 'Nkr', maximumSignificantDigits: 3 };
export const currencyOptions = { maximumFrictionDigits: 3 };

export const toPrice = (value, mainCurrency) => {
	if (value === null || value === undefined) {
		return value;
	}

	const currency = getKeyFromEnumByValue(Currencies, mainCurrency);
	return `${currency} ` + value.toLocaleString(currencyLocales, currencyOptions);
}

export const PriceField = (props) => {
	if (props.record[props.source] === null || props.record[props.source] === undefined) {
		return null;
	}

	return (
		<span>
			{toPrice(props.record[props.source], props.mainCurrency)}
		</span>
	);

	// return (
	// 	<NumberField {...props} locales={currencyLocales} options={currencyOptions} />
	// );
};

export const PriceEditableField = (props) => {
	const formatPriceField = (value) => toPrice(value, props.mainCurrency);

	const openPopupExtraCondition = props.permissions && (
		props.permissions.role === UserRole.customer_manager || 
		props.permissions.role === UserRole.customer_employee
	);

	return (
		<EditableGridCellField 
			{...props} 
			formatField={formatPriceField} 
			openPopupExtraCondition={openPopupExtraCondition} 
			EditInputComponent={NumberInput}
		/>
	);
}

PriceField.defaultProps = {
    addLabel: true,
};
